import { Sort, Add, ReminderIcon } from 'common/components/svgs';
import React from 'react';
import PropTypes from 'prop-types';
import { DownOutlined } from '@ant-design/icons';
import { Menu, Dropdown, Button, Icon } from 'antd';
import NewSearch from 'common/components/new-search';
import TextSelectFilter from 'common/components/select-filter';
import NewTabs from 'common/components/tabs';
import { extractSearchParams } from '~helpers/history';
import showElementByAuth, { isLandlordRole } from '~helpers/auth';
import { propertyListingForm, platformEntity, entityAction } from '~constants';
import { bookingJourneyType } from 'common/constants/booking';
import { trackClickPropertyListPage } from '~pages/pms-dashboard/properties/track';

export default class PropertyStatusFilter extends React.Component {
  constructor(props) {
    super(props);
    this.tagList = ['all', 'sold_out', 'rejected', 'poor_details'];
    this.popularCountriesList = ['all', 'uk', 'au', 'us'];
    this.bookingTypes = [
      {
        label: this.props.t(
          `cms:properties_booking_type_${bookingJourneyType.MANUAL.toLowerCase()}`,
        ),
        value: bookingJourneyType.MANUAL,
      },
      {
        label: this.props.t(
          `cms:properties_booking_type_${bookingJourneyType.SEMI_AUTOMATIC.toLowerCase()}`,
        ),
        value: bookingJourneyType.SEMI_AUTOMATIC,
      },
      {
        label: this.props.t(
          `cms:properties_booking_type_${bookingJourneyType.FULL_AUTOMATIC.toLowerCase()}`,
        ),
        value: bookingJourneyType.FULL_AUTOMATIC,
      },
      {
        label: this.props.t(
          `cms:properties_booking_type_${bookingJourneyType.INSTANT_BOOK.toLowerCase()}`,
        ),
        value: bookingJourneyType.INSTANT_BOOK,
      },
      {
        label: this.props.t(
          `cms:properties_booking_type_${bookingJourneyType.LEAD_GENERATION.toLowerCase()}`,
        ),
        value: bookingJourneyType.LEAD_GENERATION,
      },
    ];
  }

  getCountryMenu = () => (
    // TODO: wait platform ready
    <Menu onClick={() => {}}>
      <For each="country" of={this.popularCountriesList}>
        <Menu.Item key={country} onClick={this.handleSelectCountryFilter}>
          {this.props.t(`cms:cms.property_status_filter.countries_filter.label.${country}`)}
        </Menu.Item>
      </For>
    </Menu>
  );

  handleChangeStatus = e => {
    let value = e.value.toUpperCase().replace('-', '_');
    if (Object.values(propertyListingForm.statuses).indexOf(value) === -1) {
      value = null;
    }

    if (e?.value && e.value !== 'all') {
      trackClickPropertyListPage(e.value.charAt(0).toUpperCase() + e.value.slice(1));
    }

    this.props.onChange({ statuses: value });
  };

  handleSelectTagFilter = ({ key }) => {
    let value = key;
    if (Object.values(['sold_out', 'rejected', 'poor_details']).indexOf(key) === -1) {
      value = null;
    }

    this.props.onChange({ tag: value });
  };

  handleSelectCountryFilter = ({ key }) => {
    let value = key;
    if (Object.values(['uk', 'au', 'us']).indexOf(key) === -1) {
      value = null;
    }

    this.props.onChange({ countrySlug: value });
  };

  handleSelectSortFilter = key => {
    this.props.onChange({ sort: key });
  };

  handleTypeFilter = values => {
    this.props.onChange({ bookingJourneys: values });
  };

  getStatusFilterList = () => {
    const statusList = [
      {
        text: this.props.t('cms:cms.property_status_filter.tab.label.all_properties'),
        value: 'all',
      },
      {
        text: this.props.t('cms:cms.property_status_filter.tab.label.new'),
        value: 'new',
      },
      {
        text: this.props.t('cms:cms.property_status_filter.tab.label.editing'),
        value: 'editing',
      },
      {
        text: this.props.t('cms:cms.property_status_filter.tab.label.published'),
        value: 'published',
      },
      {
        text: this.props.t('cms:cms.property_status_filter.tab.label.unpublished'),
        value: 'unpublished',
      },
    ];

    const statusListWithOutNew = [
      {
        label: this.props.t('cms:cms.property_status_filter.tab.label.all_properties'),
        value: 'all',
      },
      {
        text: this.props.t('cms:cms.property_status_filter.tab.label.editing'),
        value: 'editing',
      },
      {
        text: this.props.t('cms:cms.property_status_filter.tab.label.published'),
        value: 'published',
      },
      {
        text: this.props.t('cms:cms.property_status_filter.tab.label.unpublished'),
        value: 'unpublished',
      },
    ];

    return isLandlordRole() ? statusList : statusListWithOutNew;
  };

  newSearchFilter = (filterArr, initArr, selectedKey, returnKey) => {
    let filterValues = [];
    filterArr.forEach(item => {
      filterValues.push(initArr.find(data => data[selectedKey] === item)[returnKey]);
    });
    return filterValues;
  };

  deletedBookFilter = (filter, defaultBookTypeFilters) => {
    let newBookTypeFilters = defaultBookTypeFilters;
    const index = defaultBookTypeFilters.indexOf(filter);
    if (index > -1) {
      newBookTypeFilters.splice(index, 1);
    }

    this.handleTypeFilter(newBookTypeFilters);
  };

  resetBookFilter = () => {
    this.handleTypeFilter([]);
  };

  setBookTypeFilters = data => {
    let newData = [];
    if (!!data && typeof data === 'string') {
      newData = data.split();
    }
    if (!!data && Array.isArray(data)) {
      newData = data.concat();
    }
    return newData;
  };

  render() {
    const { filters } = this.props;
    const { type } = extractSearchParams(filters.search);
    const bookTypeFilter = this.setBookTypeFilters(filters.bookingJourneys);

    const { statuses } = filters;
    let selectedStatusKey = 0;
    if (filters.statuses) {
      this.getStatusFilterList().forEach((item, index) => {
        if (item.value.toUpperCase() === statuses) {
          selectedStatusKey = index;
        }
      });
    }

    const SortsTypes = [
      { label: this.props.t('cms:properties_sort_by_time'), value: 'updated_at' },
      { label: this.props.t('cms:properties_sort_by_name'), value: 'name' },
    ];

    return (
      <div className="property-status-filter">
        <div className="property-status__top-header">
          <div className="property-status__top-header-title">
            {this.props.t('cms:cms.sidebar.menu.properties')}
          </div>
          <If
            condition={showElementByAuth(platformEntity.PROPERTIES_PROPERTIES, entityAction.CREATE)}
          >
            <div>
              <Button onClick={this.props.addBtn} type="primary" className="creat-property-btn">
                <Add className="creat-property-svg" />
                {this.props.t('cms:cms.properties.create.name')}
              </Button>
            </div>
          </If>
        </div>
        <div className="property-status__sub-header">
          <NewTabs
            defaultActiveKey={selectedStatusKey}
            onChange={e => {
              this.handleChangeStatus(e);
            }}
            options={this.getStatusFilterList()}
            tabPosition="top"
            className="property-status_tabs"
          />
          <div
            style={{
              width: '500px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              marginRight: '-13px',
            }}
          >
            <div>
              <NewSearch
                options={this.bookingTypes}
                onClick={() => trackClickPropertyListPage('Listing Plan Filter')}
                onChange={items => {
                  this.handleTypeFilter(items);
                }}
                placeholderInfo={{
                  title: this.props.t('cms:properties_booking_type_filter_title'),
                  filteredTitle: this.props.t('cms:properties_booking_type_title'),
                }}
                defaultCheckedFilters={bookTypeFilter}
                type="noBorder"
                noSearch
              />
            </div>
            <div>
              <TextSelectFilter
                value={this.props.sortBy}
                options={SortsTypes}
                btnText={this.props.t('cms:properties_sort_by_time')}
                filterIcon={<Sort className="property_status_sort-svg" />}
                onClick={() => trackClickPropertyListPage('Sort')}
                onSelect={item => {
                  this.handleSelectSortFilter(item);
                }}
                showSelectedOption
                noBtnBorder
                hasOutlinedIcon={false}
                isSelected={!!this.props.isSelected}
              />
            </div>
          </div>
        </div>
        <If condition={!statuses || statuses === 'NEW'}>
          <div className="reminder-box">
            <ReminderIcon className="reminderClass" />
            {this.props.t('cms:landlord_publish_new_hint')}
          </div>
        </If>
        <If condition={statuses === 'EDITING'}>
          <div className="reminder-box">
            <ReminderIcon className="reminderClass" />
            {this.props.t('cms:landlord_publish_edint_hint')}
          </div>
        </If>
        <If condition={!!bookTypeFilter.length}>
          <div className="bookingType-sub-filterbox">
            <div className="bookingType-subfilter-title">
              {this.props.t('cms:properties_booking_type_title')}:
            </div>
            <For each="bookTypeItem" of={bookTypeFilter} index="index">
              <button
                className="bookType-subfilter-btn"
                key={index}
                onClick={() => {
                  this.deletedBookFilter(bookTypeItem, bookTypeFilter);
                }}
              >
                {this.bookingTypes.find(item => item?.value === bookTypeItem)?.label}
                <Icon type="close" className="bookingType-subfilter-icon" />
              </button>
            </For>
            <div className=" bookingType-reset-btn" onClick={this.resetBookFilter}>
              {this.props.t('cms:properties_reset_filter')}
            </div>
          </div>
        </If>
        <div className="property-status-filter__filter-container">
          <If
            condition={
              (!type || ['citySlug', 'countrySlug'].indexOf(type) === -1) && !isLandlordRole()
            }
          >
            <div className="property-status-filter__country-filter">
              <Dropdown overlay={this.getCountryMenu()}>
                <a className="ant-dropdown-link">
                  <Choose>
                    <When
                      condition={this.popularCountriesList.find(
                        item => item === filters.countrySlug,
                      )}
                    >
                      <span>
                        {this.props.t(
                          `cms:cms.property_status_filter.countries_filter.label.${filters.countrySlug}`,
                        )}
                      </span>
                    </When>
                    <Otherwise>
                      {this.props.t(
                        'cms:cms.property_status_filter.countries_filter.title.filter_your_country',
                      )}
                    </Otherwise>
                  </Choose>
                  <DownOutlined />
                </a>
              </Dropdown>
            </div>
          </If>
        </div>
      </div>
    );
  }
}

PropertyStatusFilter.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  filters: PropTypes.shape({
    bookingJourneys: PropTypes.string,
    statuses: PropTypes.string,
    search: PropTypes.string,
    countrySlug: PropTypes.string,
  }),
  addBtn: PropTypes.func,
  hasHerculesProperties: PropTypes.bool,
  sortBy: PropTypes.string,
};

PropertyStatusFilter.defaultProps = {
  t: () => {},
  onChange: () => {},
  total: 0,
  filters: {
    bookingJourneys: null,
    statuses: null,
  },
  addBtn: () => {},
  hasHerculesProperties: false,
  sortBy: '',
};
